const isReactElementWithChildren = node => Boolean(node && node.props && node.props.children);

export const getNodeStringContents = node => {
  if (typeof node === 'string') {
    return node;
  }

  if (isReactElementWithChildren(node)) {
    const { children } = node.props;

    if (Array.isArray(children)) {
      return node.props.children.reduce(
        (result, child) => result + getNodeStringContents(child),
        '',
      );
    }

    return getNodeStringContents(children);
  }

  return '';
};



// WEBPACK FOOTER //
// ./src/shared/helpers/react.js